import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const yearSelector = (state, props) => whatIfInnerSelector(state, props).Year;

export const yearsOptionsSelector = (state, props) => {
  const whatIfOptions = whatIfOptionsOrDefaultSelector(state, props);
  return (whatIfOptions.YearsOptions || []).map(y => ({
    value: y,
    label: y.toString(),
  }));
};
